var exports = {
  "gJ": "treeContainer-RDFNN",
  "P": "treeTopMenu-RDFNN",
  "Ni": "treeBottomMenu-RDFNN",
  "zz": "treeWrap-RDFNN",
  "in": "focused-RDFNN",
  "B2": "tree-RDFNN",
  "TW": "dragInfoPanel-RDFNN",
  "KI": "dragInfoContent-RDFNN",
  "hC": "dragInfoParentRow-RDFNN",
  "k5": "dragInfoOperationRow-RDFNN",
  "dR": "dragInfoBranch-RDFNN",
  "x1": "dragInfoParent-RDFNN",
  "ex": "dragInfoTarget-RDFNN",
  "zv": "dragInfoDragNode-RDFNN",
  "xL": "dragInfoTargetIcon-RDFNN",
  "Yt": "dragInfoTargetTitle-RDFNN",
  "zX": "dragInfoTargetBefore-RDFNN",
  "Om": "dragInfoTargetAfter-RDFNN",
  "Co": "dragInfoTargetChild-RDFNN",
  "Yc": "dragInfoActions-RDFNN",
  "oV": "dragInfoState-RDFNN",
  "tG": "dragInfoAllowed-RDFNN",
  "l4": "dragInfoBlocked-RDFNN",
  "tU": "dragInfoClose-RDFNN",
  "J4": "dragInfoSrText-RDFNN",
  "nz": "navPath-RDFNN",
  "OS": "more-RDFNN",
  "Ng": "navPathNode-RDFNN",
  "HV": "last-RDFNN",
  "j_": "editableLabelInput-RDFNN",
};

module.exports = exports;
